import store from '@/store'

/**
 *
 * @param {Date} date date对象或时间格式字符串
 * @param {Number} timezone  时区
 */
const dateOfZone = (date = new Date(), timezone = Number(store.state.common.exhiConfig.timeZone)) => {
    let odate = date
    if (typeof date === 'string') odate = new Date(date.replace(/-/g, '/'))
    const tzOffset = odate.getTimezoneOffset()
    let offset = tzOffset * 60 * 1000
    return new Date(odate.getTime() + offset + timezone * 60 * 60 * 1000)
}

/**
 *
 * @param {*} date 日期对象
 * @param {*} format
 * formatDate(new Date().getTime());//2017-05-12 10:05:44
 * formatDate(new Date().getTime(),'YY年MM月DD日');//2017年05月12日
 * formatDate(new Date().getTime(),'今天是YY/MM/DD hh:mm:ss');//今天是2017/05/12 10:07:45
 */

const formatDate = (date, format = 'YY-MM-DD hh:mm') => {
    if (!date) return ''
    let year = date.getFullYear()
    let month = date.getMonth() + 1;  // 月份是从0开始的
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds()
    let preArr = Array.apply(null, Array(10)).map((elem, index) => {
        return '0' + index
    })/// /开个长度为10的数组 格式为 00 01 02 03

    let newTime = format.replace(/YY/g, year)
        .replace(/MM/g, preArr[month] || month)
        .replace(/DD/g, preArr[day] || day)
        .replace(/hh/g, preArr[hour] || hour)
        .replace(/mm/g, preArr[min] || min)
        .replace(/ss/g, preArr[sec] || sec)

    return newTime
}

const getLockDate = (lockInfo) => {
    let min = dateOfZone() // 默认当前时间
    if (!lockInfo) return formatDate(min)
    let { effectiveDate, realLockDate } = lockInfo
    if (!realLockDate) return formatDate(min)
    let effect = dateOfZone(new Date(effectiveDate.replace(/-/g, '/')))
    let lock = dateOfZone(new Date(realLockDate.replace(/-/g, '/')))
    if (effect < min && lock > min) {
        min = dateOfZone(new Date(realLockDate.replace(/-/g, '/')))
    }
    return formatDate(min)
}

/**
 * 获取旅行日期
 * @param {*} str
 */
const getTravelDate = (str) => {
    let date = str
    if (str) {
        let arr = str.split('~')
        if (arr.length === 2) {
            let start = arr[0].split('-')
            let end = arr[1].split('-')
            if (start[0] === end[0]) {
                date = `${arr[0]} ~ ${end[1]}-${end[2]}`
            }
        }
    }
    return date
}

/**
 * 获取本地时间转化为北京时间
 */
const getBJTime = () => {
    // 获得当前运行环境时间
    let d = new Date()
    let currentDate = new Date()
    let tmpHours = currentDate.getHours()
    // 获得时区
    let timeZone = -d.getTimezoneOffset() / 60
    // 少于0是西区，西区应该用时区绝对值加京八区，重新设置时间（西区时间比东区时间早，所以加时区间隔）
    if (timeZone < 0) {
        timeZone = Math.abs(timeZone) + 8
        currentDate.setHours(tmpHours + timeZone)
    } else {
        // 大于0是东区，东区时间直接跟京八相减
        timeZone = timeZone - 8
        currentDate.setHours(tmpHours - timeZone)
    }
    return currentDate
}

/**
 * 计算天数
 * @param {String} startDate 开始日期
 * @param {String} endDate 结束日期
 */
const __getDateLong = (startDate, endDate) => {
    startDate = startDate.replace(/-/g, '/')
    endDate = endDate.replace(/-/g, '/')
    return (new Date(`${endDate} 00:00`).getTime() - new Date(`${startDate} 00:00`).getTime()) / (1000 * 60 * 60 * 24) + 1
}

/**
 * 获取某一天日期
 * @param {String} date 基准日期
 * @param {Number} day 偏移天数
 */
const __getDateByGap = (date, day, format = 'YY-MM-DD') => {
    date = date.replace(/-/g, '/')
    let oneDay = 24 * 60 * 60 * 1000
    return formatDate(new Date(new Date(`${date} 00:00`).getTime() + day * oneDay), format)
}

/**
 * 处理日期(IE兼容)
 * @param {String} date 日期
 */
const __handleDate = (date) => {
    return date && date.replace(/-/g, '/') || '';
}

export default {
    getBJTime,
    dateOfZone,
    formatDate,
    getLockDate,
    getTravelDate,
    __getDateByGap,
    __handleDate
}
export {
    __getDateLong,
    getBJTime,
    dateOfZone,
    formatDate,
    getLockDate,
    getTravelDate,
    __getDateByGap,
    __handleDate
}
